import { useState } from 'react';
import PropTypes from 'prop-types';
import { Clipboard, ClipboardCheck } from 'lucide-react';

const SqlSection = ({ sql }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopySQL = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(sql);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = sql;
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy SQL:', err);
    }
  };

  return (
    <div className="bg-gray-50 rounded-md p-2 relative">
      <pre className="text-xs whitespace-pre-wrap pr-24">
        {sql}
      </pre>
      <div className="absolute top-2 right-2">
        <button
          onClick={handleCopySQL}
          className="flex items-center space-x-1 px-2 py-1 
            text-xs text-gray-500 hover:text-gray-700 bg-white/80 
            rounded border border-gray-200 hover:bg-gray-50 transition-colors"
        >
          {isCopied ? (
            <>
              <ClipboardCheck className="h-4 w-4" />
              <span>Copied!</span>
            </>
          ) : (
            <>
              <Clipboard className="h-4 w-4" />
              <span>Copy SQL</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

SqlSection.propTypes = {
  sql: PropTypes.string.isRequired
};

export default SqlSection; 